var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"10","height":"10","viewBox":"0 0 10 10","fill":this.color,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.791847 10L0 9.20815L4.20815 5L0 0.791847L0.791847 0L5 4.20815L9.20815 0L10 0.791847L5.79185 5L10 9.20815L9.20815 10L5 5.79185L0.791847 10Z","fill":this.color}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6100674","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Content/src/components/MyProgress/Daccord/CloseIcon.vue
// module id = 894
// module chunks = 1